export default "__VITE_ASSET__9809f748__"